import styled from 'styled-components';
import { theme, palette, ifProp } from 'styled-tools';

const S = {};

S.Trigger = styled.div`
  position: relative;
  cursor: pointer;
`;

S.Dropdown = styled.div`
  position: absolute;
  z-index: 9;
  display: ${ifProp('isOpen', 'block', 'none')};
  top: 100%;
  left: ${ifProp('openRight', '', '0')};
  right: ${ifProp('openRight', '0', '')};
  background-color: ${palette('bgDropdown')};
  box-shadow: ${theme('shadow.sm')};
  border-radius: ${theme('borderRadius.sm')};
  padding: 4px 0;
  ${theme('components.Dropdown.container')}
`;

S.DropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: ${theme('spacing.xs')} ${theme('spacing.sm')};
  color: ${palette('colorDropdownItem')};
  font-size: ${theme('fontSize.xs')};
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background-color: ${palette('bgDropdownItemHover')};
    color: ${palette('colorDropdownItemHover')};
  }

  ${theme('components.Dropdown.item')}
`;

S.DropdownItemIconElement = styled.span`
  margin-right: 10px;
`;

S.DropdownItemIcon = styled.img`
  width: 14px;
  height: auto;
  margin-right: 10px;
`;

S.DropdownItemLabel = styled.span``;

export default S;
